const STORAGE_KEY = 'recentApps';

export function getRecentApps(): string[] {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data).map((id: string) => id.trim()) : [];
}

export function updateRecentApps(appId: string) {
    const recent = getRecentApps().filter(id => id !== appId);
    recent.unshift(appId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent.slice(0, 3)));
}